import {
    ColoursObj,
    Icon,
    MainButton,
    TEventrIcons,
    Typography,
} from '@eventr/common-storybook'
import { MenuItem, Popover, Stack } from '@mui/material'
import { useState } from 'react'

interface TopToolbarProps {
    title?: string
    subtitle?: string
    profilePage?: boolean
    leadingItems?: ToolbarItemProps[]
    trailingItems?: ToolbarItemProps[]
}

export interface ToolbarItemProps {
    id: string
    buttonText?: string
    icon?: TEventrIcons
    colour?: string
    action?: () => void
    popoverItems?: PopoverItemProps[]
    useButton?: boolean
    disabled?: boolean
    profilePage?: boolean
}

export interface PopoverItemProps {
    id?: string
    title: string
    action?: () => void
    color?: string
    active?: boolean
}

/// idk why props wasent typed here...
export const ToolbarItem = ({ props }: { props: ToolbarItemProps }) => {
    const [anchoredElement, setAnchoredElement] = useState<
        (EventTarget & Element) | null
    >(null)
    const popoverIsOpen = Boolean(anchoredElement)

    const closePopover: () => void = () => {
        setAnchoredElement(null)
    }

    return (
        <>
            <div>
                <div
                    id={props.id}
                    onClick={(event) => {
                        if (props.disabled) return
                        if (props.action) {
                            props.action()
                        }

                        if (props.popoverItems) {
                            setAnchoredElement(event.currentTarget)
                        } else {
                            closePopover()
                        }
                    }}
                >
                    {props.useButton ? (
                        <Stack>
                            <Stack>
                                <MainButton
                                    id={props.id}
                                    text={props.buttonText}
                                    variant="borderless"
                                    fontColour={props.colour}
                                    disabled={props.disabled}
                                />
                            </Stack>
                        </Stack>
                    ) : (
                        <Stack
                            width="32px"
                            height="32px"
                            borderRadius="16px"
                            bgcolor={ColoursObj.shades.shade4}
                        >
                            <Stack margin="auto">
                                <Icon
                                    iconColour={
                                        props.disabled
                                            ? ColoursObj.shades.shade3
                                            : ColoursObj.shades.shade1
                                    }
                                    name={props.icon ?? 'Activity'}
                                />
                            </Stack>
                        </Stack>
                    )}
                </div>

                {props.popoverItems && (
                    <Popover
                        open={popoverIsOpen}
                        onClose={closePopover}
                        anchorEl={anchoredElement}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'right',
                        }}
                        slotProps={{
                            paper: {
                                style: {
                                    border:
                                        '1px solid ' + ColoursObj.shades.shade3,
                                    borderRadius: '8px',
                                    // TODO: Static shadow below
                                    boxShadow:
                                        '0px 8px 16px 0px rgba(16, 55, 92, 0.10)',
                                    marginTop: '8px',
                                    background: ColoursObj.backgrounds.primary,
                                },
                            },
                        }}
                    >
                        {props.popoverItems.map((popoverItem, index) => {
                            return (
                                <MenuItem
                                    id={popoverItem.id}
                                    key={index}
                                    disabled={
                                        popoverItem.active === undefined
                                            ? false
                                            : !popoverItem.active
                                    }
                                    onClick={() => {
                                        if (popoverItem.action) {
                                            popoverItem.action()
                                        }
                                        closePopover()
                                    }}
                                    style={{
                                        borderTop:
                                            index === 0
                                                ? 'unset'
                                                : '1px solid ' +
                                                  ColoursObj.shades.shade3,
                                    }}
                                >
                                    <Typography
                                        variant="bodyRegular"
                                        color={
                                            popoverItem.color ??
                                            ColoursObj.core.primary
                                        }
                                    >
                                        {popoverItem.title}
                                    </Typography>
                                </MenuItem>
                            )
                        })}
                    </Popover>
                )}
            </div>
        </>
    )
}

export const TopToolbar = ({
    title,
    subtitle,
    leadingItems,
    trailingItems,
}: TopToolbarProps) => {
    const titleTypography = title && (
        <Typography variant="bodyBold" textAlign="center" margin="auto">
            {title}
        </Typography>
    )

    const subtitleTypography = subtitle && (
        <Typography
            variant="bodySubtext"
            paddingY="4px"
            textAlign="center"
            margin="auto"
        >
            {subtitle}
        </Typography>
    )

    return (
        <>
            <Stack
                direction="row"
                paddingX="16px"
                paddingBottom="8px"
                justifyContent="space-between"
                alignItems="center"
                bgcolor={ColoursObj.backgrounds.primary}
            >
                <Stack direction="row" gap="8px" minWidth="32px">
                    {leadingItems &&
                        leadingItems.map((toolbarItem, index) => {
                            return (
                                <div key={index}>
                                    <ToolbarItem props={toolbarItem} />
                                </div>
                            )
                        })}
                </Stack>

                <Stack height="48px">
                    {titleTypography}
                    {subtitleTypography}
                </Stack>

                <Stack direction="row" gap="8px" minWidth="32px">
                    {trailingItems &&
                        trailingItems.map((toolbarItem, index) => {
                            return (
                                <div key={index}>
                                    <ToolbarItem props={toolbarItem} />
                                </div>
                            )
                        })}
                </Stack>
            </Stack>
        </>
    )
}
